export default __webpack_public_path__ + "static/media/bigLogoDark.55fd1f0c.svg";